import { Container, Link as MuiLink, Stack, Typography } from "@mui/material";
import type { NavbarHeaderRenderProps } from "@ssf/auth-components";
import { S4HorseLogo } from "@ssf/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { generatePath } from "../lib";

export const Header = ({ collapsed }: NavbarHeaderRenderProps) => {
  const { t } = useTranslation("Header");

  if (!collapsed) return null;

  return (
    <Container sx={{ maxWidth: "100% !important" }}>
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: "center",
          minHeight: 48,
        }}
      >
        <MuiLink
          component={Link}
          to={generatePath("tournaments", {})}
          sx={{
            mr: "auto",
            svg: { width: 32, mr: 0.5 },
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <S4HorseLogo />
          <Typography component="h1" variant="h4">
            {t("title")}
          </Typography>
        </MuiLink>
      </Stack>
    </Container>
  );
};
